// Global Privacy Control. When the browser sends it, we treat it as an opt-out of sharing for
// advertising (see the Privacy Policy): no Meta Pixel, Meta server events, Google Ads or Triple Whale.
// index.html sets window.__aerGpc before any tag loads; this is the same check for app code.
export function gpcEnabled() {
  if (typeof window === "undefined") return false;
  return window.__aerGpc === true || window.navigator?.globalPrivacyControl === true;
}
